import moment from "moment";

export const setPetAge = (dob: string) => {
    const diffInYears = moment().diff(dob, "years");
    if (!diffInYears) {
	    const diffInMonths = moment().diff(dob, "months");
	    if(diffInMonths === 1) {
            return `${diffInMonths} month old`;
        }
        if(!diffInMonths) {
            return ">1 month old";
        }
        return `${diffInMonths} months old`;
    }
    return `${diffInYears} years old`;
};

export const setPetType = (type: string) => {
    switch (type) {
        case "FELINE":
        case "Cat":
            return "FELINE";
        case "CANINE":
        case "Dog":
            return "CANINE";
        case "AVIAN":
        case "Birds":
            return "AVIAN";
        case "AMPHIBIAN":
        case "Amphibian":
            return "AMPHIBIAN";
        case "AQUATIC":
        case "Aquatic":
            return "AQUATIC";
        case "MUSTELIDAE":
        case "Mustelidae":
            return "MUSTELIDAE";
        default:
            return "Other";
    }
};

export const setPetAgeShort = (dob) => {
    const diffInYears = moment().diff(dob, "years");
    if (!diffInYears) {
        const diffInMonths = moment().diff(dob, "months");
        if(diffInMonths === 1) {
            return `${diffInMonths} Month`;
        }
        if(!diffInMonths) {
            return ">1 Month";
        }
        return `${diffInMonths} Months`;
    }
    return `${diffInYears} Years`;
};

export const setPetAgeVetView = (dob) => {
    const diffInMonths = moment().diff(dob, "months");
    const yearsExtracted = Math.trunc(diffInMonths / 12);
    const monthsRemains = diffInMonths % 12;
    if(!yearsExtracted) {
        if(!monthsRemains) {
            return "<1 mo";
        }
        return `${monthsRemains} ${monthsRemains > 1 ? "mos" : "mo"}`;
    } else {
        let ageString = `${yearsExtracted} ${yearsExtracted > 1 ? "yrs" : "yr"}`;
        if(!monthsRemains) {
            return ageString;
        }
        return `${ageString} & ${monthsRemains} ${monthsRemains > 1 ? "mos" : "mo"}`;
    }
};
